import { isForeignCitizenship } from "./agreementDocumentsAccess";

interface PaperScansManageInput {
  /** Czy użytkownik ma uprawnienie agreements_paper_confirm_recruiter (PR, DR, DO, KAM, leasing/outsourcing, admin) */
  hasPermission: boolean;
  /** Nazwa obywatelstwa z zatwierdzonego kwestionariusza (non_draft) */
  citizenshipName?: string | null;
}

/**
 * Czy sekcja „Załączniki" (skany umowy papierowej, ASMMNT-83 etap 2) jest widoczna.
 * Tylko umowy obcokrajowców — ten sam warunek co checkboxy potwierdzeń.
 */
export function isPaperScansSectionVisible(
  citizenshipName?: string | null,
): boolean {
  return isForeignCitizenship(citizenshipName);
}

/** Czy użytkownik może dodawać i usuwać skany (przyciski „Dodaj" / „Usuń"). Odczyt nazw ma każdy z dostępem do umowy. */
export function canManagePaperScans({
  hasPermission,
  citizenshipName,
}: PaperScansManageInput): boolean {
  return hasPermission && isPaperScansSectionVisible(citizenshipName);
}
